<script lang="ts" setup>
import { TaskLoaderState } from '@/composeables';
import { featureIcons } from '@/.';
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        /**
         * The state of the loader
         */
        state?: TaskLoaderState | 'spin' | 'success' | 'error';

        /**
         * The font family to use
         */
        family?: string;

        /**
         * If the loader should show a success icon
         * @default false
         */
        showSuccess?: boolean;

        /**
         * The size of the icon
         */
        size?: '1x' | '2x' | '3x' | '4x' | '5x';
    }>(),
    {
        family: 'fa-light',
        showSuccess: false,
    },
);

const computedState = computed(() => {
    if (!props.state) {
        return null;
    }

    if (props.state instanceof TaskLoaderState) {
        if (props.state.isActive || !props.state.AllDone) {
            return 'spin';
        } else if (props.state.AllDone && props.state.Failed.length > 0) {
            return 'error';
        } else if (props.state.AllDone && props.state.Failed.length == 0) {
            return 'success';
        }
    }
    return props.state;
});
</script>

<template>
    <span
        class="eq-icon"
        v-if="computedState"
    >
        <font-awesome-icon
            v-if="computedState == 'spin'"
            :icon="`${family} fa-spinner-third`"
            class="text-primary fa-spin"
            :class="[size ? `fa-${size}` : '']"
        />
        <font-awesome-icon
            v-if="computedState == 'error'"
            :icon="`${family} ${featureIcons.ERROR}`"
            class="text-danger"
            :class="[size ? `fa-${size}` : '']"
        />
        <font-awesome-icon
            v-if="computedState == 'success' && showSuccess"
            :icon="`${family} ${featureIcons.SUCCESS}`"
            class="text-success"
            :class="[size ? `fa-${size}` : '']"
        />
    </span>
</template>
